module.exports = __webpack_public_path__ + "img/3.5b1d2745.png";